import { HospitalCtx } from './Context';

export { HospitalCtx };
